import logo from "./logo.svg";
import "./App.css";
import { SearchBeans } from "./pages/search";
import NewSearchBeans  from './pages/searchNew';

function App() {
  return (
    <div className="App">
      <NewSearchBeans />
    </div>
  );
}

export default App;
